const verification_record = {
    not_found: 'لم يتم العثور على سجل التحقق.',
    permission_denied: 'تم رفض الإذن، يرجى إعادة التحقق.',
    not_supported_for_google_one_tap: 'هذا الـ API لا يدعم Google One Tap.',
};
export default Object.freeze(verification_record);
